export function Spinner() {
  return (
    <div className="flex justify-center items-center">
      <div className="w-8 h-8 border-4 border-grey-500 border-dashed rounded-full animate-spin"></div>
    </div>
  );
}
